export default "__VITE_ASSET__CZFMZO8c__"